var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare21CSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 44",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M30 41.5a2.5 2.5 0 0 1-2.5 2.5h-19A2.5 2.5 0 0 1 6 41.5v-19A2.5 2.5 0 0 1 8.5 20h19a2.5 2.5 0 0 1 2.5 2.5v19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M8.5 42h19a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .5.5Zm19 2a2.5 2.5 0 0 0 2.5-2.5v-19a2.5 2.5 0 0 0-2.5-2.5h-19A2.5 2.5 0 0 0 6 22.5v19A2.5 2.5 0 0 0 8.5 44h19Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.5 13.5A2.5 2.5 0 0 1 15 16H3.5A2.5 2.5 0 0 1 1 13.5v-10A2.5 2.5 0 0 1 3.5 1h14v12.5ZM35 13.5a2.5 2.5 0 0 1-2.5 2.5H21a2.5 2.5 0 0 1-2.5-2.5V1h14A2.5 2.5 0 0 1 35 3.5v10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M35 12a1 1 0 0 1-1-1V3.5A1.5 1.5 0 0 0 32.5 2h-29A1.5 1.5 0 0 0 2 3.5V11a1 1 0 1 1-2 0V3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgSquare21CSelected.viewBox = '0 0 36 44';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare21CSelected);
export default ForwardRef;